import React, { useCallback, useEffect, useState } from "react";
import { connect } from "react-redux";

import {
  EMPTY_STRING,
  privacyPolicyConstants,
} from "../../constants";
import MainSpinner from "../../shared/components/spinner/MainSpinner";
import convertContentToHTML from "../../shared/utility-functions/ConvertContentToHtml";
import MainContentWrapper from "../../shared/components/main-content-wrapper/MainContentWrapper";
import { privacyPolicyActions } from "../../redux/actions";
import Topbar from "../../layout/Topbar";
import Footer from "../../layout/Footer";

const { GET_PRIVACY_POLICY, ADD_OR_UPDATE_PRIVACY_POLICY } =
  privacyPolicyConstants;

const PrivacyPolicy = (props) => {
  const { privacyPolicy, spinnerActions, getPrivacyPolicy } = props;

  const [htmlContent, setHtmlContent] = useState(EMPTY_STRING);

  const spinner = useCallback(
    (type) => spinnerActions.findIndex((s) => s === type),
    // eslint-disable-next-line
    [spinnerActions]
  );

  useEffect(() => {
    if (privacyPolicy?.content) {
      const html = convertContentToHTML(privacyPolicy.content);
      setHtmlContent(html);
    }
  }, [privacyPolicy]);

  useEffect(() => {
    getPrivacyPolicy();

    // eslint-disable-next-line
  }, []);

  return (
    <>
      <Topbar />
      {(spinner(GET_PRIVACY_POLICY) > -1 ||
        spinner(ADD_OR_UPDATE_PRIVACY_POLICY) > -1) && <MainSpinner />}
      <MainContentWrapper>
        <div className="container">
          <div className="about-us-heading">Privacy Policy</div>
          {spinner(GET_PRIVACY_POLICY) === -1 && (
            <div
              dangerouslySetInnerHTML={{ __html: htmlContent }}
              className="mt-4"
            />
          )}
        </div>
      </MainContentWrapper>
      <Footer />
    </>
  );
};

const mapStateToProps = (state) => ({
  spinnerActions: state.systemReducer.spinnerActions,
  privacyPolicy: state.privacyPolicyReducer.privacyPolicy,
});

const mapDispatchToProps = (dispatch) => ({
  getPrivacyPolicy: () => dispatch(privacyPolicyActions.getPrivacyPolicy()),
});

export default connect(mapStateToProps, mapDispatchToProps)(PrivacyPolicy);
